// extracted by mini-css-extract-plugin
module.exports = {"container":"CareerNavigation_container__ZX0D6","title":"CareerNavigation_title__XXpWL","pathList":"CareerNavigation_pathList__aImb7"};